import { createContext, useContext, useEffect, useState } from 'react';
import { getMe, loginDirectus, logoutDirectus } from './directusClient';

const Ctx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [bootstrapping, setBootstrapping] = useState(true);

    useEffect(() => {
        getMe().then(setUser).finally(() => setBootstrapping(false));
    }, []);

    async function login(email, password) {
        const me = await loginDirectus(email, password);
        setUser(me);
        return me;
    }

    async function logout() {
        await logoutDirectus();
        setUser(null);
    }

    return (
        <Ctx.Provider value={{ user, login, logout, bootstrapping }}>
            {children}
        </Ctx.Provider>
    );
}

export const
    useAuth = () => useContext(Ctx);
